import type WhiteboardController from '../controllers/WhiteboardController';
import ToolPaste from '../tools/ToolPaste';

const addTestHelpers = (controller: WhiteboardController) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  // @ts-expect-error used by playwright tests
  window.pasteRecordsForTesting = async contents =>
    await ToolPaste.pasteContents(controller, contents);
};

export default addTestHelpers;
